/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Video_Export_Alpha_Failed_Code_ToastInputs */



/**
* | output |
* | --- |
* | "Alpha video export failed with code: {code}" |
*
* @param {Video_Export_Alpha_Failed_Code_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_failed_code_toast = /** @type {((inputs: Video_Export_Alpha_Failed_Code_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Failed_Code_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'exportation video alpha avec le code : ${i?.code}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Alpha-Videoexport fehlgeschlagen mit Code: ${i?.code}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'esportazione del video Alpha non è riuscita con il codice: ${i?.code}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео завершился с ошибкой: ${i?.code}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La exportación de video alfa falló con el código: ${i?.code}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Alpha 视频导出失败，错误代码：${i?.code}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アルファ ビデオのエクスポートがコード ${i?.code} で失敗しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात विफल रहा, कोड: ${i?.code}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A exportação do vídeo alfa falhou com o código: ${i?.code}`)
	return /** @type {LocalizedString} */ (`Alpha video export failed with code: ${i?.code}`)
});